<template>
  <div class="salers c:col-start-stretch">
    <Empty v-if="list.length == 0 && !loading" text="暂无员工" />
    <div class="salers-wrapper">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="getSaleList"
      >
        <saler-list-cell
          v-for="(item, index) in list"
          :key="index"
          :data="item"
      /></van-list>
    </div>
    <CBottomPad is-tab-page />
  </div>
</template>
<script>
import { getEmployeeList } from "@/api";
import CBottomPad from "@/components/common/CBottomPad.vue";
import Empty from "@/components/common/Empty.vue";
import SalerListCell from "@/components/saler-list/SalerListCell.vue";
import normalPage from "@/mixins/normal-page";
import { mapGetters } from "vuex";

export default {
  mixins: [normalPage],
  components: {
    Empty,
    SalerListCell,
    CBottomPad,
  },
  props: ["type"],
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      finishedText: "",
    };
  },
  computed: {
    ...mapGetters(["currentStore"]),
  },
  mounted() {
    // this.getSaleList();
  },
  methods: {
    async getSaleList() {
      try {
        this.list = [];
        const res = await getEmployeeList({
          storeId: this.currentStore.storeId,
        });
        this.list = res;
        console.log(this.list);
        this.finishedText = "";
      } catch (error) {
        console.log("getSalers error", error);
        this.finishedText = "";
      } finally {
        this.loading = false;
        this.finished = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.salers {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  user-select: none;
}

.salers-wrapper {
  flex: 1;
  width: 100%;
  height: 0;
  padding-top: 4/20rem;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 0;
}
</style>
